<script>
    import { onMount } from 'svelte';

    let token = "";
    let isLoading = true;

    onMount(() => {
        // Extract the token from the URL (e.g., /start/eyJhbG...)
        const pathParts = window.location.pathname.split('/');
        
        // Grab the last part of the URL path
        token = pathParts[pathParts.length - 1];
        
        console.log("Test Token extracted:", token);
        
        // Simulate a loading delay (you will replace this with your actual API call later)
        setTimeout(() => {
            isLoading = false;
        }, 1000);
    });
</script>

<div class="test-container">
    {#if isLoading}
        <h2>Loading your test...</h2>
    {:else}
        <h2>Test Started Successfully!!!!!!!!!!!!!!!!</h2>
        <p>Good luck!</p>
        
        <div class="debug-info">
            <p><strong>Debug - Token:</strong></p>
            <code>{token}</code>
        </div>
    {/if}
</div>

<style>
    .test-container {
        padding: 40px;
        text-align: center;
        font-family: sans-serif;
    }
    .debug-info {
        margin-top: 30px;
        padding: 15px;
        background-color: #f4f4f4;
        border-radius: 5px;
        word-break: break-all; /* Ensures the long token doesn't break the page layout */
    }
</style>